<template>
  <base-modal :show="show"
              :padding="false"
              size="small"
              @close="close" >
    <div slot="header">
      {{ $t("geofence.title") }}
    </div>
    <geofence-configure-screen :mode="fromBus.mode"
                               :named-location-id="fromBus.id"
                               :location-from-history="fromBus.locationFromHistory" />
  </base-modal>
</template>

<script>
  import GeofenceConfigureScreen from '@/components/Common/Geofence/GeofenceConfigureScreen'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      GeofenceConfigureScreen
    },

    data() {
      return {
        fromBus: {
          mode: '',
          id: null,
          locationFromHistory: null
        }
      }
    },

    beforeMount() {
      this.setOpenListener('geofence-configure')
    }
  }
</script>
